import axios from '../../axios'

/**
 * 查询 科二科三 教学日志轨迹
 * @param {*} data 
 * 
licnum	是	string	车牌号
reportStartTime	是	string	培训开始时间
reportEndTime	是	string	培训结束时间
reportTime	是	string	培训时间 yyyyddmm

 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19170732 
 */
export const listPathCoordinate = data => {
  return axios({
    url: '/location/getLocationClassnum',
    method: 'post', data
  })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/record/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/record/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/record/list',
        method: 'post',
        data
    })
}
// 明细查询
export const detailView = (data) => {
    return axios({
        url: '/record/detail',
        method: 'post',
        data
    })
}
// 上报日志
export const report = (data) => {
  return axios({
    url: '/record/report',
    method: 'post',
    data
  })
}
// 复制日志
export const copy = (data) => {
  return axios({
    url: '/record/copy',
    method: 'post',
    data
  })
}
// 同步日志
export const recordSync = (data) => {
  return axios({
    url: '/record/network/sync',
    method: 'post',
    data
  })
}
// 过程头像
export const viewPic = (data) => {
  return axios({
    url: '/record/viewPic',
    method: 'post',
    data
  })
}
// 过程明细
export const getClassHourRecord = (data) => {
  return axios({
    url: '/hourRecord/getHourRecord',
    method: 'post',
    data
  })
}
// 过程明细头像
export const getHourRecordPhoto = (data) => {
  return axios({
    url: '/hourRecord/getHourRecordPhoto',
    method: 'post',
    data
  })
}
export const getLocation = (data) => {
  return axios({
    url: '/location/getLocation',
    method: 'post',
    data
  })
}
export const getLocationCurrent = (data) => {
  return axios({
    url: '/location/getLocationCurrent',
    method: 'post',
    data
  })
}

// 同步上报学时
export const syncStageBatch = (data) => {
  return axios({
    url: '/record/recordSync',
    method: 'post',
    data
  })
}
export const buSign = (data) => {
  return axios({
    url: '/record/suppSign',
    method: 'post',
    data
  })
}
export const getHourRecordPhotoByDeviceId = (data) => {
  return axios({
    url: '/hourRecord/getHourRecordPhotoByDeviceId',
    method: 'post',
    data
  })
}

// 复制日志
export const lessionCopy = (data) => {
  return axios({
    url: '/record/lessionCopy',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/classrecord/classrecord.js